(function () {
  'use strict';

  var audio = document.getElementById('lb-ambient-audio');
  var btn = document.querySelector('.lb-audio-toggle');
  var widget = document.querySelector('.lb-audio-widget');
  var minimizeBtn = document.querySelector('.lb-audio-minimize');
  if (!audio || !btn || !widget || !minimizeBtn) return;

  var STORAGE_KEY = 'lb-audio-user-paused';
  var COLLAPSE_KEY = 'lb-audio-collapsed';
  var userPaused = sessionStorage.getItem(STORAGE_KEY) === '1';
  var gestureBound = false;

  audio.volume = 0.42;
  audio.loop = true;

  function setPlaying(playing) {
    btn.classList.toggle('lb-audio-toggle--playing', playing);
    widget.classList.toggle('lb-audio-widget--playing', playing);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    btn.setAttribute('aria-label', playing ? 'Pause O Sole Mio' : 'Play O Sole Mio');
  }

  function setCollapsed(collapsed) {
    widget.classList.toggle('lb-audio-widget--collapsed', collapsed);
    minimizeBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    minimizeBtn.setAttribute('aria-label', collapsed ? 'Expand player' : 'Minimize player');
    if (collapsed) {
      sessionStorage.setItem(COLLAPSE_KEY, '1');
    } else {
      sessionStorage.removeItem(COLLAPSE_KEY);
    }
  }

  function play() {
    return audio.play().then(function () {
      setPlaying(true);
      sessionStorage.removeItem(STORAGE_KEY);
    }).catch(function () {
      setPlaying(false);
    });
  }

  function pause() {
    audio.pause();
    setPlaying(false);
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  function bindGestureFallback() {
    if (gestureBound || userPaused) return;
    gestureBound = true;

    var once = function () {
      if (sessionStorage.getItem(STORAGE_KEY) !== '1' && audio.paused) {
        play();
      }
      document.removeEventListener('pointerdown', once, true);
      document.removeEventListener('keydown', once, true);
    };

    document.addEventListener('pointerdown', once, true);
    document.addEventListener('keydown', once, true);
  }

  btn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (audio.paused) {
      play();
    } else {
      pause();
    }
  });

  minimizeBtn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    setCollapsed(!widget.classList.contains('lb-audio-widget--collapsed'));
  });

  if (sessionStorage.getItem(COLLAPSE_KEY) === '1') {
    setCollapsed(true);
  }

  if (userPaused) {
    setPlaying(false);
    return;
  }

  play().finally(function () {
    if (audio.paused) {
      bindGestureFallback();
    }
  });
})();
